import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { Link } from "react-router-dom";

import {
  StyledLogo,
  Nav,
  StyledLink,
  ApplicationTitle,
  NavWrapper,
  StyledLinkTab,
} from "./style";
import { Button, Menu, MenuItem } from "@mui/material";
import { FaChevronDown } from "react-icons/fa";


interface Props {
  onLogout: () => void
  userEmail: string
  tabsOptions: Array<{ to: string; label: string }>;
  currentTab: number;
  onChangeTab: (
    event: React.SyntheticEvent<Element, Event>,
    newTab: number
  ) => void; 
}

export default function HeaderView({
  onLogout,
  userEmail,
  currentTab,
  onChangeTab,
  tabsOptions,
}: Props) {
  const [isMenuShown, toggleMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onToggleMenu = (event) => {
    toggleMenu(!isMenuShown);
    setAnchorEl(event.currentTarget as HTMLElement);
  };

  return (
    <NavWrapper>
      <StyledLink to="/">
        <StyledLogo />
        <ApplicationTitle variant="h3">
          Intelligent Feedstock Flow
        </ApplicationTitle>
      </StyledLink>
      <Nav>
        <Tabs
          indicatorColor="primary"
          value={currentTab}
          onChange={onChangeTab}
        >
          {tabsOptions.map((option: { to: string; label: string }) => {
            return (
              <StyledLinkTab
                component={Link}
                label={option.label}
                to={option.to}
                key={option.label}
              />
            );
          })}

        </Tabs>
      </Nav>
      <AuthenticatedTemplate>
        <Button
          color="secondary"
          endIcon={<FaChevronDown size="16px" />}
          onClick={onToggleMenu}
          sx={{marginRight: "16px"}}
          variant="outlined"
        >
          {userEmail}
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={isMenuShown}
          onClick={onToggleMenu}
          anchorOrigin={{ horizontal: "right",vertical: "bottom" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={onLogout}>Log out</MenuItem>
        </Menu>
      </AuthenticatedTemplate>
    </NavWrapper>
  );
}
